module.exports = __webpack_public_path__ + "media/images/telegram-bb986b518f88a3c7d78bf4f7df57d517.png";